import script from "./BookingSourcePieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingSourcePieChart.vue?vue&type=script&setup=true&lang=js"

import "./BookingSourcePieChart.vue?vue&type=style&index=0&id=6516b4ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6516b4ee"]])

export default __exports__